import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=71c3f0f0&scoped=true"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3f0f0",
  null
  
)

export default component.exports